export default "__VITE_ASSET__Gdh7rMOd__"